export default "__VITE_ASSET__CimTDLn9__"